import {RootState} from 'common/src/redux/store';
import {poll} from '../../../utils/poll';
import {PollResult} from '../../../copilot.types';

export default async function waitForNavigationCompletion({
  getState,
  isNavigationComplete,
}: {
  getState: () => RootState;
  isNavigationComplete: (getState: () => RootState) => boolean;
}): Promise<PollResult> {
  const result = await poll({
    checkFn: (): PollResult => {
      const isLoaded = isNavigationComplete(getState);

      if (!isLoaded) {
        return {passed: false, reason: 'Route is not loaded'};
      }

      return {passed: true};
    },
    maxAttempts: 50,
    interval: 100,
  });

  if (!result.passed) {
    return {
      passed: false,
      reason: `Navigation initiated but route loading failed: ${result.reason}`,
    };
  }

  return {passed: true};
}
